import { Link, makeStyles, tokens } from '@fluentui/react-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCallbackQueueOpen } from '../../../libs/hooks/useCallbackQueueOpen';
import { CallbackModal } from '../callback/CallbackModal';

const useClasses = makeStyles({
    root: {
        alignSelf: 'center',
        fontSize: tokens.fontSizeBase200,
    },
});

export const QueueTimeoutCallbackOffer: React.FC = () => {
    const classes = useClasses();
    const { t } = useTranslation();
    const isCallbackQueueOpen = useCallbackQueueOpen();
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!isCallbackQueueOpen) {
        return null;
    }

    return (
        <div className={classes.root}>
            <Link
                appearance="subtle"
                onClick={() => {
                    setIsModalOpen(true);
                }}
                data-testid="queue-timeout-callback-offer"
            >
                {t('callback.callInsteadLink')}
            </Link>
            <CallbackModal isOpen={isModalOpen} onOpenChange={setIsModalOpen} />
        </div>
    );
};
